import React, { useState, useCallback } from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import client from './Client';
import Features from './Features';
import CurrentUser from './CurrentUser';
import Project from './Project';
import ErrorBoundary from 'ErrorBoundary';

const App = ({ children, project }) => {
  const [projectContext, updateProject] = useState(project || window && window._project || {});
  const updateProjectAttributes = useCallback((attributes) => {
    updateProject({ ...projectContext, ...attributes });
  }, [projectContext, updateProject]);

  return (
    <ErrorBoundary>
      <CurrentUser.Provider value={window && window._currentUser}>
        <Features.Provider value={window && window._featureContext}>
          <Project.Provider value={{ update: updateProjectAttributes, ...projectContext }}>
            <ApolloProvider client={client}>
              {children}
            </ApolloProvider>
          </Project.Provider>
        </Features.Provider>
      </CurrentUser.Provider>
    </ErrorBoundary>
  );
};

export const connectedApp = (WrappedComponent) => {
  const wrappedApp = ({ project, ...props }) => (
    <App project={project}>
      <WrappedComponent {...props} />
    </App>
  );

  return wrappedApp;
};

export default App;
